import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpRequestResponse } from '../../../lib/models/http-request-response.model';
import { HttpRequestService } from '../../../lib/services/http-request.service';
import { LogService } from '../../../lib/services/log.service';
import { newError } from '../../../lib/utils/Utility';
import { MatFormField, MatLabel, MatInput, MatHint } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MenuPortaleComponent } from '../components/menu-portale.component';
import { PortaleLayoutFooterComponent } from '../../layout/portale-layout-footer/portale-layout-footer.component';

@Component({
    selector: 'ev-contact-form',
    templateUrl: './contattaci.component.html',
    styleUrls: ['./contattaci.component.scss', '../../../lib/themes/portale.theme.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatHint, MatCheckbox, MatButton, MenuPortaleComponent, PortaleLayoutFooterComponent]
})
export class ContattaciComponent {
  private logService = inject(LogService);
  private httpRequestService = inject(HttpRequestService);
  private router = inject(Router);

  title = 'Contattaci';

  form = new FormGroup({
    subject: new FormControl('', [Validators.required]),
    from: new FormControl('', [Validators.required, Validators.email]),
    message: new FormControl('', [Validators.required, Validators.maxLength(350)]),
    accepted: new FormControl(false, [Validators.requiredTrue])
  })


  invia() {

    const data = this.form.getRawValue()

    this.httpRequestService.post('/send-mail/', data)
      .subscribe((response) => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          this.router.navigate(['/'], {});
        } else {
          this.logService.messageError(
            'Errore',
            response.message,
            newError(response.message)
          );
        }
      });
  }
}
